export default __webpack_public_path__ + "static/media/lion.5a575da7.png";